// extracted by mini-css-extract-plugin
export default {"container":"MiningOverview_container__AKAWo","left":"MiningOverview_left__DKThF","right":"MiningOverview_right__lHNvk"};